module.exports = __webpack_public_path__ + "static/media/bg.5c3f35a8.png";